Ext.define('SA.ViewActionsMenuButton2', {
    alias: 'widget.view-actions-menu-button-2',
    extend: 'SA.view.MenuButton',

    margin: '0 10 0 0',
    text: 'View Actions',

    initComponent() {
        this.callParent();

        this.createMenuCfg();
    },

    createMenuCfg() {
        this.menu = {
            xtype: 'menu',

            items: this.menuItems.map(item => {
                if (item.xtype === 'menuseparator') {
                    return item;
                }

                return {...item, handler: () => this.fireEvent(`click:menuItem:${item.eventId}`)};
            })
        };
    }
});